module.exports = __webpack_public_path__ + "img/update-dns.ee877422.png";